module.exports = __webpack_public_path__ + "img/truc1.d93e0f5e.png";